import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
export type ReviewDTO =  {
    id:string;
    rating: number;
    name:string;
    review: string;
    createdAt:string;
    updatedAt:string
}

interface ReviewData {
    reviewData: ReviewDTO[];
}
interface ReviewResponse {
    data?: ReviewData;
    error?: ApiError;
}

export const getReviews = async (): Promise<ReviewResponse> => {
    try {
        const response = await axios.get("/review/all");
        return { data: { reviewData: response.data } };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};